import { createReducer, on } from '@ngrx/store';
import { updateFundChartSecurityOrdering } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/securities/securities.actions';
import { setFundChartSortDirection } from './sort-direction.actions';
export const sortDirection = createReducer('', on(setFundChartSortDirection, (state, action) => {
    return action.sortDirection;
}), on(updateFundChartSecurityOrdering, () => {
    return '';
}));
